module.exports = __webpack_public_path__ + "static/blog_grid_5-dc59bc48af645592355018a49073f606.jpg";